import React, { createContext, useState, useContext, useEffect } from 'react';

const AdminContext = createContext();

export const useAdmin = () => {
  const context = useContext(AdminContext);
  if (!context) {
    throw new Error('useAdmin must be used within an AdminProvider');
  }
  return context;
};

export const AdminProvider = ({ children }) => {
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(false);
  const [adminData, setAdminData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if admin is already logged in
    const token = localStorage.getItem('adminToken');
    const admin = localStorage.getItem('adminData');
    
    if (token && admin && admin !== 'undefined' && admin !== 'null') {
      try {
        const parsedAdmin = JSON.parse(admin);
        if (parsedAdmin && typeof parsedAdmin === 'object') {
          setAdminData(parsedAdmin);
          setIsAdminAuthenticated(true);
        } else {
          throw new Error('Invalid admin data structure');
        }
      } catch (error) {
        console.error('Error parsing admin data:', error);
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminData');
      }
    }
    setLoading(false);
  }, []);

  const adminLogin = (admin, token) => {
    localStorage.setItem('adminToken', token);
    localStorage.setItem('adminData', JSON.stringify(admin));
    setAdminData(admin);
    setIsAdminAuthenticated(true);
  };

  const adminLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminData');
    setAdminData(null);
    setIsAdminAuthenticated(false);
  };

  const getAuthHeaders = () => {
    const token = localStorage.getItem('adminToken');
    return token ? { 
      'Authorization': `Bearer ${token}`,
      'x-auth-token': token 
    } : {};
  };

  return (
    <AdminContext.Provider
      value={{
        isAdminAuthenticated,
        adminData,
        loading,
        adminLogin,
        adminLogout,
        getAuthHeaders
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};
